import { IFilter, IWhere } from 'types/common'
import { api } from 'API'
import { ICommonLibrary } from 'interfaces/commonLibrary'
import { getValidArray } from 'utils/common'

const BASE = '/common-libraries'

export async function getCommonLibraryComponents(
  stepKeyword: string = '',
  limit?: number,
  offset?: number,
  sort?: string,
  dependentProcessIds?: number[]
): Promise<{ paginatedResults: ICommonLibrary[]; totalResults: number }> {
  const response = await api.post(`${BASE}/aggregate`, { stepKeyword, limit, offset, sort, dependentProcessIds })
  return response.data
}

export async function getCommonSteps(filter: IFilter<ICommonLibrary> = {}): Promise<ICommonLibrary[]> {
  const response = await api.get(`${BASE}/?filter=${JSON.stringify(filter)}`)
  return response.data ?? []
}

export async function countCommonStep(where: IWhere<ICommonLibrary> = {}): Promise<number> {
  const response = await api.get(`${BASE}/count?where=${JSON.stringify(where)}`)
  return response?.data?.count ?? 0
}

export async function addAllStepOfProcessToCommonLibrary(processId: number): Promise<void> {
  await api.post(`${BASE}/add-all-steps/processes/${processId}`)
}

export async function addStepToCommonLibrary(data: Partial<ICommonLibrary>): Promise<void> {
  await api.post(`${BASE}`, data)
}

export async function removeStepFromCommonLibrary(commonStepId: number): Promise<void> {
  if (!commonStepId) return
  await api.delete(`${BASE}/${commonStepId}`)
}

export async function removeMultiStepFromCommonLibrary(commonStepIds: number[]): Promise<void> {
  if (getValidArray(commonStepIds).length === 0) return
  await api.post(`${BASE}/delete-many`, commonStepIds)
}
